module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonerebranding-04@2x.935b7851.jpg";